import {
   createOverviewQueryRestoreGuard,
   skipDefaultFilterGuardsWhenRememberModeOn,
} from '@/core/helpers/remember-last-used-filters.helper';
import EMPLOYER_GUARD from '@/core/guards/employer.guard';
import TEAM_GUARD from '@/core/guards/team.guard';
import store from '@/core/store';
import type { NavigationGuard } from 'vue-router';

const rememberedFiltersTeamGuard = skipDefaultFilterGuardsWhenRememberModeOn('performancesOverview', TEAM_GUARD);

const performancesTeamGuard: NavigationGuard = (to, from, next) => {
   if (store.state.userInfo?.userInfo?.is_contact_user) return TEAM_GUARD(to, from, next);
   return rememberedFiltersTeamGuard(to, from, next);
};

export function performancesOverviewGuards(): NavigationGuard[] {
   return [
      createOverviewQueryRestoreGuard('performancesOverview'),
      skipDefaultFilterGuardsWhenRememberModeOn('performancesOverview', EMPLOYER_GUARD),
      performancesTeamGuard,
   ];
}
